import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'
import type { BillingInterval } from './useGetBillingSubscription'

export interface PlanPrice {
  /** cents */
  amount: number
  currency: string
}

export interface Plan {
  plan_key: string
  name: string
  description: string | null
  prices: Partial<Record<BillingInterval, PlanPrice>>
}

export default function useGetPlans({ enabled = true } = {}) {
  return useQuery<Plan[]>({
    queryKey: ['billing-plans'],
    queryFn: async () => {
      const response = await httpClient.get('billing/plans')
      return response.data
    },
    enabled,
    staleTime: 10 * 60 * 1000,
  })
}
